import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { TeamPaymentRequestsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const clearDashboardPaymentRequest = (data): any => action(types.CLEAR_DASHBOARD_PAYMENT_REQUEST, data);

export const updateDashboardPaymentRequest = (data): any => action(types.UPDATE_DASHBOARD_PAYMENT_REQUEST, data);

export const createDashboardTeamPaymentRequest = (data): any => action(types.CREATE_DASHBOARD_TEAM_PAYMENT_REQUEST_REQUESTED, data);

export const updateDashboardTeamPaymentRequest = (data): any => action(types.UPDATE_DASHBOARD_TEAM_PAYMENT_REQUEST_REQUESTED, data);

export const deleteDashboardTeamPaymentRequest = (teamPaymentRequestId): any => action(types.UPDATE_DASHBOARD_TEAM_PAYMENT_REQUEST_REQUESTED, teamPaymentRequestId);

export const getDashboardTeamPaymentRequest = (teamPaymentRequestId): any => action(types.GET_DASHBOARD_TEAM_PAYMENT_REQUEST_REQUESTED, teamPaymentRequestId);

export const getAllDashboardTeamPaymentRequests = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_DASHBOARD_TEAM_PAYMENT_REQUESTS_REQUESTED, { pagination, compile });

export const selectDashboardTeamPaymentRequest = (teamPaymentRequestId): any => action(types.SELECT_DASHBOARD_TEAM_PAYMENT_REQUEST_REQUESTED, { currentDashboardTeamPaymentRequestId: teamPaymentRequestId });

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createDashboardTeamPaymentRequestPending: (payload): any => action(types.CREATE_DASHBOARD_TEAM_PAYMENT_REQUEST_PENDING, payload),
  createDashboardTeamPaymentRequestSuccess: (response): any => action(types.CREATE_DASHBOARD_TEAM_PAYMENT_REQUEST_SUCCESS, {
    teamPaymentRequestsById: response.entities.teamPaymentRequests,
    currentDashboardTeamPaymentRequestId: response.result,
  }),
  updateDashboardTeamPaymentRequestPending: (payload): any => action(types.UPDATE_DASHBOARD_TEAM_PAYMENT_REQUEST_PENDING, payload),
  updateDashboardTeamPaymentRequestSuccess: (response): any => action(types.UPDATE_DASHBOARD_TEAM_PAYMENT_REQUEST_SUCCESS, {
    teamPaymentRequestsById: response.entities.teamPaymentRequests,
    currentDashboardTeamPaymentRequestId: response.result,
  }),
  updateDashboardTeamPaymentRequestFailed: (error): any => action(types.UPDATE_DASHBOARD_TEAM_PAYMENT_REQUEST_FAIL, { backendErrors: error }),
  deleteDashboardTeamPaymentRequestPending: (): any => action(types.UPDATE_DASHBOARD_TEAM_PAYMENT_REQUEST_PENDING, {}),
  deleteDashboardTeamPaymentRequestSuccess: (response, userId): any => {
    localStorage.set(userId, { currentDashboardTeamPaymentRequestId: null });
    // history.push('/teamPaymentRequests');

    return action(types.DELETE_DASHBOARD_TEAM_PAYMENT_REQUEST_SUCCESS, {
      currentDashboardTeamPaymentRequestId: response,
    });
  },
  getDashboardTeamPaymentRequestPending: (): any => action(types.GET_DASHBOARD_TEAM_PAYMENT_REQUEST_PENDING, {}),
  getDashboardTeamPaymentRequestSuccess: (response): any => action(types.GET_DASHBOARD_TEAM_PAYMENT_REQUEST_SUCCESS, {
    teamPaymentRequestsById: response.entities.teamPaymentRequests,
    currentDashboardTeamPaymentRequestId: response.result,
  }),
  getDashboardTeamPaymentRequestFailed: (error): any => action(types.GET_DASHBOARD_TEAM_PAYMENT_REQUEST_FAIL, { backendErrors: error }),
  deleteDashboardTeamPaymentRequestFailed: (error): any => action(types.UPDATE_DASHBOARD_TEAM_PAYMENT_REQUEST_FAIL, { backendErrors: error }),
  getAllDashboardTeamPaymentRequestsPending: (pagination): any => action(types.GET_ALL_DASHBOARD_TEAM_PAYMENT_REQUESTS_PENDING, { pagination }),
  getAllDashboardTeamPaymentRequestsSuccess: (response, meta): any => action(types.GET_ALL_DASHBOARD_TEAM_PAYMENT_REQUESTS_SUCCESS, {
    teamPaymentRequestsById: response.entities.teamPaymentRequests,
    teamPaymentRequestIds: response.result,
    meta,
  }),
  getAllDashboardTeamPaymentRequestsFailed: (error): any => action(types.GET_ALL_DASHBOARD_TEAM_PAYMENT_REQUESTS_FAIL, { backendErrors: error }),
  createDashboardTeamPaymentRequestFailed: (error): any => action(types.CREATE_DASHBOARD_TEAM_PAYMENT_REQUEST_FAIL, { backendErrors: error }),
};

export default null;
